import { Component, output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SelectedLocation } from '@era/stores';
import { DeviceLinkSelectorComponent } from '../../device-link/device-link-selector/device-link-selector.component';
import { PairingCodeContainerComponent } from '../pairing-code/pairing-code.container';

@Component({
  selector: 'era-pairing-request',
  templateUrl: './pairing-request.component.html',
  styleUrls: ['./pairing-request.component.scss'],
  imports: [DeviceLinkSelectorComponent, PairingCodeContainerComponent],
})
export class PairingRequestComponent {
  readonly cancelled = output<boolean>();

  public selection: SelectedLocation = { brandId: 'default-brand', isValid: false };

  public readonly unassignedControl = new UntypedFormControl(false);
  public currentTab = 0;

  public get allowNext() {
    return this.currentTab !== 1 || this.selection.isValid;
  }

  public nextWithoutSelection() {
    this.selection = { brandId: 'default-brand', isValid: true };
    this.next();
  }

  public next() {
    if (this.currentTab < 2) {
      this.currentTab = this.currentTab + 1;
    }
  }

  public previous() {
    if (this.currentTab > 0) {
      this.currentTab = this.currentTab - 1;
    }
  }

  public cancel() {
    this.cancelled.emit(true);
  }
}
